module.exports = __webpack_public_path__ + "img/阵雪.295a8210.png";